import {
  GET_CATEGORIES,
  ADD_CART,
  USER_DATA,
  UPDATE_CART,
  SINGLE_BLOG,
  SINGLE_MY_ORDER,
} from "./actions";

export const GetCategories = (data) => {
  // console.log("GetCatagories");
  return (dispatch) => {
    dispatch({
      type: GET_CATEGORIES,
      categories: data,
    });
  };
};

export const AddCart = (data) => {
  return {
    type: ADD_CART,
    payload: data,
  };
};

export const StoreUserData = (data) => {
  return {
    type: USER_DATA,
    payload: data,
  };
};

export const UpdateCart = (data) => {
  return {
    type: UPDATE_CART,
    payload: data,
  };
};

export const SingleBlog = (data) => {
  // console.log(data, "dddddddddddddddddddaaaaaaaaaa")
  return {
    type: SINGLE_BLOG,
    payload: data,
  };
};

export const SingleMyOrder = (data) => {
  // console.log(data,"dddddddddddddddddddaaaaaaaaaa")
  return {
    type: SINGLE_MY_ORDER,
    payload: data,
  };
};
// export const GetProductsByCategory = (payload) => {
//     console.log("GetCatagories");
//     return performQuery(Query.getProductOnCollection, { categoryId: "gid://shopify/Collection/274985025583" }).then(response => {
//         console.log(response.data, "response.data");
//         return response.data
//     }).catch((err) => {
//         console.log(err, "eeeeeeeerrrrrrrr");
//     })
// };
